import PropTypes from 'prop-types';
import styles from './spinner.module.scss';

export default function Spinner({ showSpinner = false, wrapperClass = '' }) {
  return (
    <div>
      {showSpinner && (
        <div className={wrapperClass}>
          <div className={styles.mask} />
          <div className={styles.logo} />
        </div>
      )}
    </div>
  );
}

Spinner.propTypes = {
  showSpinner: PropTypes.bool,
  wrapperClass: PropTypes.string,
};
